import { makeValuesPredicate, not } from '@sgme/fp';
import type { Action } from 'state/actions';
import { addOrPatchKey } from 'state/utils/collection';

import type { QuoteActionsUiAction } from './quoteActions.action';
import type { QuoteActionsUiState, QuoteActionsUiStateMap } from './quoteActions.model';

export function quoteActionsUiReducer(state: QuoteActionsUiStateMap = {}, action: Action): QuoteActionsUiStateMap {
  switch (action.type) {
    case 'QUOTE_ACTION_SELECTED':
      return addOrPatchKey(state, action.tabId, previousState => {
        return updateState(previousState, action);
      });

    default:
      return state;
  }
}

const filterTradableQuote = not(makeValuesPredicate(['TradableQuote', 'AdvancedTradableQuote']));
const filterExecOnly = not(makeValuesPredicate(['ExecOnly', 'AdvancedExecOnly']));
const filterIndicativeQuote = not(makeValuesPredicate(['IndicativeQuote', 'AdvancedIndicativeQuote']));
const filterExecutableQuote = not(makeValuesPredicate(['ExecutableQuote', 'AdvancedExecutableQuote']));

function updateState(previousState: QuoteActionsUiState, action: QuoteActionsUiAction): QuoteActionsUiState {
  if (!Array.isArray(previousState?.selectedActions)) {
    return {
      selectedActions: [action.name],
    };
  }

  const previouslySelectedActions = previousState.selectedActions;

  switch (action.name) {
    case 'TradableQuote':
    case 'AdvancedTradableQuote': {
      const selectedActions = previouslySelectedActions.filter(filterTradableQuote);
      selectedActions.push(action.name);

      return {
        selectedActions,
      };
    }

    case 'ExecOnly':
    case 'AdvancedExecOnly': {
      const selectedActions = previouslySelectedActions.filter(filterExecOnly);
      selectedActions.push(action.name);

      return {
        selectedActions,
      };
    }

    case 'IndicativeQuote':
    case 'AdvancedIndicativeQuote': {
      const selectedActions = previouslySelectedActions.filter(filterIndicativeQuote);
      selectedActions.push(action.name);

      return {
        selectedActions,
      };
    }

    case 'ExecutableQuote':
    case 'AdvancedExecutableQuote': {
      const selectedActions = previouslySelectedActions.filter(filterExecutableQuote);
      selectedActions.push(action.name);

      return {
        selectedActions,
      };
    }

    default:
      throw new Error(`Action reducer '${action.type}/${action.name}' is not yet implemented`);
  }
}
